module.exports = __webpack_public_path__ + "static/media/domain.e13fde61.svg";